import React, { useRef, useState, useEffect } from 'react';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';

interface TruncatedTextProps {
    text: string;
    style?: React.CSSProperties;
}

export const TruncatedText: React.FC<TruncatedTextProps> = ({ text, style }) => {
    const spanRef = useRef<HTMLSpanElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const el = spanRef.current;
        if (el) {
            setIsTruncated(el.scrollWidth > el.clientWidth);
        }
    }, [text]);

    return (
        <TooltipHost content={isTruncated ? text : ''}>
            <span
                ref={spanRef}
                style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: 'block',
                    ...style
                }}
            >
                {text}
            </span>
        </TooltipHost>
    );
};
